import { loadable } from '../../../utils';

export const Basic = loadable(() => import('./Basic'), {});
export const Seo = loadable(() => import('./Seo'), {});
